import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./Dashboard";
import DocsPage from "./docs/DocsPage";
import MemberPage from "./member/MemberPage";
import EventPage from "./event/EventPage";
import AssociatePage from "./associate/AssociatePage";
import ManagePage from "./manage/index";
import AppPage from "./app/index";
import SettingPage from "./setting/index";
import MsfPage from "./msf/MsfPage";
import { LayoutSplashScreen } from "../../../_metronic";

export default function HomePage() {
  // useEffect(() => {
  //   console.log('Home page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        {/* Redirect from root URL to /dashboard. */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/associate/*" element={<AssociatePage />} />
        <Route path="/member/*" element={<MemberPage />} />
        <Route path="/event/*" element={<EventPage />} />
        <Route path="/manage/*" element={<ManagePage />} />
        <Route path="/setting/*" element={<SettingPage />} />
        <Route path="/app/*" element={<AppPage />} />
        <Route path="/msf/*" element={<MsfPage />} />
        <Route path="/resctricted" element={<DocsPage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="*" element={<Navigate to="/error/error1" replace />} />
      </Routes>
    </Suspense>
  );
}
